import type {
  PdfiumApi,
  PdfiumTypeMap,
  Pointer,
} from "@pdfking/renderer-wasm-pdfium"
import type { Bytes } from "@pdfking/tfunc"
import { Broadcast, ToBlob } from "@pdfking/tfunc"

type PointerDoc = PdfiumTypeMap["FPDF_DOCUMENT"]

export const SaveDocument = (
  { safeCall, malloc, setInt32, readBytes, addCallback }: PdfiumApi,
  doc_pointer: PointerDoc
): AsyncGenerator<Blob> => {
  const { stop, push, subscribe } = Broadcast<Blob>()
  const subscriber = subscribe()

  const write_callback = (_: number, data: number, size: number) => {
    push(ToBlob(readBytes(data as Pointer, size as Bytes)))
    return size
  }

  const runner = async () => {
    const { pointer: callbackPtr, free: freeCallback } = addCallback(
      write_callback,
      "iiii"
    )
    const { pointer: structPtr, free: freeStruct } = malloc(8 as Bytes)

    setInt32(structPtr, 1)
    setInt32((structPtr + 4) as Pointer, callbackPtr)

    try {
      await safeCall("FPDF_SaveAsCopy", doc_pointer, structPtr, 2)
      stop(undefined)
    } catch (e) {
      stop(e as Error)
    } finally {
      freeStruct()
      freeCallback()
    }
  }

  void runner()

  return subscriber
}
